const middleware = {}

middleware['allowNonMember'] = require('../src/app/middleware/allowNonMember.ts')
middleware['allowNonMember'] = middleware['allowNonMember'].default || middleware['allowNonMember']

middleware['applicationForm'] = require('../src/app/middleware/applicationForm.ts')
middleware['applicationForm'] = middleware['applicationForm'].default || middleware['applicationForm']

middleware['canAccessMemberApp'] = require('../src/app/middleware/canAccessMemberApp.ts')
middleware['canAccessMemberApp'] = middleware['canAccessMemberApp'].default || middleware['canAccessMemberApp']

middleware['fetchUser'] = require('../src/app/middleware/fetchUser.ts')
middleware['fetchUser'] = middleware['fetchUser'].default || middleware['fetchUser']

middleware['hasBeenInducted'] = require('../src/app/middleware/hasBeenInducted.ts')
middleware['hasBeenInducted'] = middleware['hasBeenInducted'].default || middleware['hasBeenInducted']

middleware['initializer'] = require('../src/app/middleware/initializer.ts')
middleware['initializer'] = middleware['initializer'].default || middleware['initializer']

middleware['isAuthorized'] = require('../src/app/middleware/isAuthorized.ts')
middleware['isAuthorized'] = middleware['isAuthorized'].default || middleware['isAuthorized']

middleware['publicOnly'] = require('../src/app/middleware/publicOnly.ts')
middleware['publicOnly'] = middleware['publicOnly'].default || middleware['publicOnly']

export default middleware
